export const singlePropReducer =
	(name, defaultValue) =>
	(state, { payload } = { payload: defaultValue }) => {
		state[name] = payload;
	};
